module.exports = __webpack_public_path__ + "static/img/office (12).36668c5f.jpg";